import React from 'react';
import { Info } from 'lucide-react';

const InformacionInstitucional = ({ data, handlers }) => {
    return (
        <div className="bg-white rounded-2xl p-5 md:p-6 shadow-sm border border-slate-100">
            <div className="flex items-center gap-2 mb-4 border-b border-slate-100 pb-3">
                <Info className="w-4 h-4 text-blue-600" />
                <h2 className="text-base font-semibold text-slate-800">Información Institucional</h2>
            </div>

            <div className="space-y-4">
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Misión</label>
                    <textarea 
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm resize-none"
                        rows="2"
                        placeholder="Describe la misión de la institución..."
                        value={data.mision}
                        onChange={(e) => handlers.setMision(e.target.value)}
                    ></textarea>
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Visión</label>
                    <textarea 
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm resize-none"
                        rows="2"
                        placeholder="Describe la visión a futuro..."
                        value={data.vision}
                        onChange={(e) => handlers.setVision(e.target.value)}
                    ></textarea>
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Historia</label>
                    <textarea 
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm resize-none"
                        rows="3"
                        placeholder="Breve reseña histórica de la junta..."
                        value={data.historia}
                        onChange={(e) => handlers.setHistoria(e.target.value)}
                    ></textarea>
                </div>
            </div>
        </div>
    );
};

export default InformacionInstitucional;
